<ng-container *ngIf="favorites.length > 0">
  <h4 class="carousel-title">Bookmarked Courses</h4>
  <app-course-slideshow [courses]="favorites"></app-course-slideshow>
</ng-container>
